import { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { SocialLinkConfig } from '../../SocialLink';
import FacebookSVG from './assets/facebook.svg';
import InstagramSVG from './assets/instagram.svg';
import TwitterSVG from './assets/twitter.svg';
import YouTubeSVG from './assets/youtube.svg';
import { msgs } from './messages';

export const useSocialLinks = (): SocialLinkConfig[] => {
  const intl = useIntl();

  return useMemo(
    () => [
      {
        mediaType: 'facebook',
        SocialLogo: FacebookSVG,
        ariaLabel: intl.formatMessage(msgs.ariaLabelFacebook),
        href: 'https://www.facebook.com/memrise',
      },
      {
        mediaType: 'twitter',
        SocialLogo: TwitterSVG,
        ariaLabel: intl.formatMessage(msgs.ariaLabelTwitter),
        href: 'https://www.twitter.com/memrise',
      },
      {
        mediaType: 'youtube',
        SocialLogo: YouTubeSVG,
        ariaLabel: intl.formatMessage(msgs.ariaLabelYouTube),
        href: 'https://www.youtube.com/user/memrise',
      },
      {
        mediaType: 'instagram',
        SocialLogo: InstagramSVG,
        ariaLabel: intl.formatMessage(msgs.ariaLabelInstagram),
        href: 'https://www.instagram.com/memrise',
      },
    ],
    [intl],
  );
};
